<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Wajib Retribusi</li>
              </ol>
            </div>
            <h4 class="page-title">Wajib Retribusi</h4>
          </div>
        </div>
      </div>

      <!-- {{search_custom}} -->

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <div class="clearfix">
                    <button @click.prevent="sAlert('error', 'Harap mengkonfirgurasi form customer terlebih dahulu')" class="btn btn-success waves-effect waves-light left-action" v-if="!is_can_create">Tambah Wajib Retribusi</button>
                    <router-link :to="{ name: 'instanceCustomerCreate' }" class="btn btn-success waves-effect waves-light left-action" v-if="is_can_create">Tambah Wajib Retribusi</router-link>
                    <div class="float-right">
                        <button type="button" class="btn btn-dark waves-effect waves-light" @click.prevent="openModalSetting">
                            <i class="fas fa-cog"></i>
                        </button>
                    </div>
                </div>  
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Kode</th>
                                <th>Nama</th>
                                <th v-for="item in tableHeader" :key="item">{{item.label}}</th>
                                <th>Aksi</th>
                            </tr>
                            <tr>
                                <th style="padding: 0px; !important"><input type="text" class="form-control" placeholder="Cari ..." v-model="search.customer_code" @input="onSearch"></th>
                                <th style="padding: 0px; !important"><input type="text" class="form-control" placeholder="Cari ..." v-model="search.name" @input="onSearch"></th>
                                <th style="padding: 0px; !important" v-for="item in search_custom" :key="item"><input type="text" class="form-control" placeholder="Cari ..." v-model="item.value" @input="onSearch"></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataCustomer" :key="item.id">
                                <td>{{item.customer_code}}</td>
                                <td>{{item.name}}</td>
                                <td v-for="customItem in item.customField" :key="customItem.id">
                                    {{customItem.field_value}}
                                </td>
                                <td>
                                    <button class="btn btn-warning waves-effect waves-light" @click.prevent="exportCustomer(item.name, item.customer_code, item.id, item.export_count)"
                                    :disabled="loadingDownloadPDF"
                                    v-if="companyType == 'HEALTH_CARE'">
                                        <div class="spinner-border" role="status" v-if="loadingDownloadPDF">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <i class="fas fa-print" v-else></i>
                                    </button>
                                    <router-link class="btn btn-primary waves-effect waves-light ml-2"
                                        :to="{ name: 'instanceCustomerEdit', params: { id: item.id } }"
                                        >
                                        <i class="fas fa-pen"></i>
                                    </router-link>
                                    <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id)" 
                                        v-if="$store.state.permission.includes('customer.delete')">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="clearfix mt-3">
                    <div class="float-right">
                        <paginate 
                            v-model="paging.currentPage"
                            :page-count="paging.rows" :page-range="3" :margin-pages="2" :click-handler="paginate"
                            :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-link'" :next-class="'page-link'"
                            :container-class="'pagination mb-0'" :page-link-class="'page-link'" :page-class="'page-item'" align="right">
                        </paginate>
                    </div>
                </div>
            </div>
          </div>
      </div>


      <div class="modal fade" id="modalSetting" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mt-0" id="mySmallModalLabel">
                        Pengaturan Tabel
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6" v-for="(item, index) in allField" :key="item.id">
                            <div class="checkbox my-2">
                                <div class="custom-control custom-checkbox">
                                    <input type="text" class="custom-control-input" id="kode" v-model="allField[index].id">
                                    <input type="checkbox" class="custom-control-input" :id="item.name" v-model="allField[index].is_show_on_dataset">
                                    <label class="custom-control-label" :for="item.name">{{ item.label }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <!-- <div class="row" style="margin: 0px 5px;">
                        <div class="col-12" style="display: none">
                            <input type="file" id="file" ref="file" v-on:change="excelFunction('import')"/>
                        </div>
                        <div class="col-12 col-md-4" style="padding: 0px 5px">
                            <button type="button" class="btn btn-success waves-effect waves-light mr-2 w-100"
                                @click="$refs.file.click()">
                                <i class="fas fa-upload mr-1"></i>
                                Import Excel
                            </button>
                        </div>
                        <div class="col-12 col-md-4" style="padding: 0px 5px">
                            <button type="button" class="btn btn-warning waves-effect waves-light mr-2 w-100"
                                @click.prevent="excelFunction('export')">
                                <i class="fas fa-download mr-1"></i>
                                Export Excel
                            </button>
                        </div>
                        <div class="col-12 col-md-4" style="padding: 0px 5px">
                            <button type="button" class="btn btn-primary waves-effect waves-light mr-2 w-100"
                                @click.prevent="excelFunction('download-template')">
                                <i class="fas fa-file-excel mr-1"></i>
                                Template Excel
                            </button>
                        </div>
                    </div> -->
                    <hr>
                    <div class="row d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" @click="saveTableSetting">Simpan</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import fileDownload from 'js-file-download'

import { debounce } from "debounce"

export default {
    data() {
        return {
            loading: true,
            loadingDownloadPDF: false,
            tableHeader: [],
            allField: [],
            dataCustomer: [],

            search: {
                customer_code: null,
                name: null,
            },

            search_custom: [],

            paging:{
                rows: 0,
                currentPage: 1,
                perPage: 10,
                total: 0,
                to: 0,
            },

            is_can_create: null
        }
    },
    methods: {
        saveTableSetting() {
            const storedData = this.allField.map(item => {
                return {
                    id: item.id,
                    is_show_on_dataset: item.is_show_on_dataset
                }
            })
            this.$http.put(`${this.API_URL}custom-field/update`, storedData, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            }).then(res => {
                $('#modalSetting').modal('hide')
                this.loadData()
            }).catch(error => {
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        exportCustomer(name,code,id,export_count) {

            this.loadingDownloadPDF = true


            const filename = `${name.split(' ').join('-')}-${code}.pdf`
            if(export_count > 0){
                Swal.fire({
                    title: 'Apakah anda yakin untuk menambahkan data ini ke laporan registrasi',
                    showCancelButton: true,
                    showDenyButton: true,

                    confirmButtonText: 'Ya',
                    cancelButtonText: 'Batal',
                    denyButtonText: 'Tidak',

                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#808080',
                    denyButtonColor: '#D33',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.$http.get(`${this.API_URL}customer/export/${id}?is_store_to_registration=1`, {
                            responseType: 'blob',
                            headers: { 
                                'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                            }
                        })
                        .then(response => {
                            this.loadingDownloadPDF = false
                            fileDownload(response.data, filename);
                        })
                        .catch(error => {
                            this.loadingDownloadPDF = false
                        })

                        this.loadData()
                    }else if(result.isDenied){
                        this.$http.get(`${this.API_URL}customer/export/${id}`, {
                            responseType: 'blob',
                            headers: { 
                                'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                            }
                        })
                        .then(response => {
                            this.loadingDownloadPDF = false
                            fileDownload(response.data, filename);
                        })
                        .catch(error => {
                            this.loadingDownloadPDF = false
                        })
                    }else{
                        Swal.close()
                        this.loadingDownloadPDF = false
                    }
                }) 
            }else{
                this.$http.get(`${this.API_URL}customer/export/${id}?is_store_to_registration=1`, {
                    responseType: 'blob',
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                })
                .then(response => {
                    this.loadingDownloadPDF = false
                    fileDownload(response.data, filename);
                })
                .catch(error => {
                    this.loadingDownloadPDF = false
                })

                this.loadData()
            }
        },
        openModalSetting() {
            $('#modalSetting').modal('show')

            this.$http.get(`${this.API_URL}company-setting`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            }).then(res => {
                const idTemplate = res.data.data.customer_form_id
                this.$http.get(`${this.API_URL}form-template/${idTemplate}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                }).then(res => {
                    this.allField = res.data.data.custom_fields.map(item => {
                        return {
                            id: item.id,
                            label: item.label,
                            name: item.name,
                            is_show_on_dataset: item.is_show_on_dataset
                        }
                    })
                })
            })
            .catch(error => {
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        excelFunction(state){
            let url = null
            let format = null
            
            if(state == 'download-template'){
                this.$http.get(`${this.API_URL}customer/excel-template`, {
                    responseType: 'blob',
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                })
                .then(response => {
                    fileDownload(response.data, `Wajib-Retribusi-Template-Excel-File-${Date.now()}.xlsx`);
                })
                .catch(error => {
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                })
            }else if(state == 'export'){
                this.$http.get(`${this.API_URL}customer/export`, {
                    responseType: 'blob',
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                })
                .then(response => {
                    fileDownload(response.data, `Wajib-Retribusi-Excel-File-${Date.now()}.xlsx`);
                })
                .catch(error => {
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                })
            }else{
                const formData = new FormData
                formData.append('file', this.$refs.file.files[0])

                this.$http.post(`${this.API_URL}customer/import`,
                    formData,
                    {
                        headers: { 
                            'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                        }
                    }
                )
                .then(response => {
                    $('#modalSetting').modal('hide')
                    this.loadData()
                })
                .catch(error => {
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                }) 
            }
        },

        paginate(page){
            this.$router.push({
                name: 'instanceCustomer',
                query: {
                    // keywords: null,
                    page: page,
                }
            })

            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;

            this.loadData(page)
        },

        getMostCustomField(data) {
            var longest = 0;
            var longestData = [];
            data.forEach(function(item) {
                if (item.fields.length > longest) {
                    longestData = [item];
                    longest = item.fields.length;
                } else if (item.fields.length == longest) {
                    // longestData.push(item);
                }
            });
            return longestData[0];
        },

        onSearch() {
            this.searchHeader(this);
        },
        searchHeader: debounce(async (vm) => {
            vm.loadData(1)
        }, 1500),

        /* ----------------------------- BASIC FUNCTION ----------------------------- */
        async loadData(page) {
            this.loading = true
            
            // GET COMPANY SETTING
            const company = await this.$http.get(`${this.API_URL}company-setting`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            this.is_can_create = company.data.data.customer_form_id

            let text
            if(this.search_custom.length > 0){
                let index = 0
                for await (const element of this.search_custom) {
                    if(index == 0){
                        text = `?custom_fields[${index}][id]=${element.id}`
                        text = text + `&custom_fields[${index}][value]=${element.value}`
                    }else{
                        text = text + `&custom_fields[${index}][id]=${element.id}`
                        text = text + `&custom_fields[${index}][value]=${element.value}`
                    }

                    index++
                    // this.search_custom[index]['value'] = element.value
                    // this.search_custom[index] = element.
                }

            }

            // for (let index = 0; index < this.search_custom.length; index++) {
            //     if(index == 0){
            //         text = `?custom_fields[${index}]['id']=${this.search_custom[index].id}`
            //         text = text + `&custom_fields[${index}]['value']=${this.search_custom[index].value}`
            //     }else{
            //         text = text + `&custom_fields[${index}]['id']=${this.search_custom[index]}`
            //         text = text + `&custom_fields[${index}]['value']=${element.value}`
            //     }
            // }


            this.$http.get(`${this.API_URL}customer${text ? text : ''}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` },
                params: {
                    page: page ? page : this.$route.query.page,
                    ...this.search,
                    with_fields: 1
                }
            })
            .then(response => {
                this.loading = false;
                
                const result = response.data;

                if(result.success) {
                    if(result.data.data.length <= 0){
                        this.dataCustomer = []
                        return
                    }

                    if(result.data.data[0]) {
                        // if(result.data.data[0].fields.length > 0){
                            if(this.getMostCustomField(result.data.data)){

                                this.tableHeader = this.getMostCustomField(result.data.data).fields.map(item => {
                                    return {
                                        label: item.custom.label,
                                        name: item.custom_field_id
                                    }
                                })

                                this.search_custom = []

                                this.getMostCustomField(result.data.data).fields.forEach((element, index) => {
                                    
                                    this.search_custom.push({
                                        id: element.custom_field_id,
                                        value: null
                                    })
                                    // this.search_custom[index]['id'] = element.custom_field_id
                                    // this.search_custom[index]['value'] = null
                                    // this.search[element.custom.name] = this.search[element.custom.name] ?? null
                                });
                                

                                this.dataCustomer = result.data.data.map(item => {
                                    return {
                                        id: item.id,
                                        export_count: item.export_count,
                                        customer_code: item.customer_code,
                                        name: item.name,
                                        customField: item.fields
                                    }
                                })
                            }
                        // }
                    }else{
                        this.tableHeader = []
                        this.dataCustomer = result.data.data.map(item => {
                            return {
                                id: item.id,
                                export_count: item.export_count,
                                customer_code: item.customer_code,
                                name: item.name,
                            }
                        })
                    }

                    this.paging.rows = result.data.last_page
                    this.paging.currentPage = result.data.current_page
                    this.paging.perPage = result.data.per_page
                    this.paging.total = result.data.total
                    this.paging.to = result.data.to

                    // setTimeout(() => {
                    //     this.dataTableSearch()
                    // }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                console.log(error);
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        deleteItem(id){
            Swal.fire({
            title: 'Apakah anda yakin untuk menghapus ?<br> <b>Data ini memiliki relasi dengan data lainnya, pastikan dengan baik!<b>',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.value) {
                     this.loading = true
                     this.$http.delete(`${this.API_URL}customer/delete/${id}`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })
                    .then(() => {
                        this.loadData()
                    })
                    .catch(error => {
                        this.loading = false;
                        this.errorHandler(error)
                    });
                }
            })
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>